export default "__VITE_ASSET__Do8iv$Rr__"